import React, { useState } from 'react';
import axios from 'axios';

const S3FileUpload = ({ 
  hideLabel = false, 
  label = "Upload your file", 
  uploadPath,
  dragMessage = "Drag & Drop your file here or click to browse",
  fileType = "File",
  onComplete = null
 }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setUploadError(null);
    setUploadSuccess(null);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    
    if (!selectedFile) return;

    setUploading(true);
    setUploadError(null);
    setUploadSuccess(null);

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axios.post(uploadPath, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setUploading(false);

      if(onComplete){
        onComplete()
      }
    } catch (error) {
      setUploading(false);
      setUploadError(`${fileType} upload failed. Please try again.`);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
    
    const file = event.dataTransfer.files[0];
    setSelectedFile(file);
    setUploadError(null);
    setUploadSuccess(null);
  };

  const handleCancelClick = () => {
    setSelectedFile(null);
    setUploadError(null);
    setUploadSuccess(null);
    setUploading(false);
  };

  return (
    <form onSubmit={handleFormSubmit} className="container border-bottom py-4">
      <div 
        className={`mb-3 p-4 border ${dragActive ? 'border-primary' : 'border-secondary'}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        { !hideLabel ? 
        (<label htmlFor="formFile" className="form-label">
          { label }
        </label>)
        : null 
        }
        <input
          className="form-control"
          type="file"
          id="formFile"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ cursor: 'pointer', height: '100px' }}
          onClick={() => document.getElementById('formFile').click()}
        >
          {selectedFile ? (
            <span>{selectedFile.name}</span>
          ) : (
            <span>{ dragMessage }</span>
          )}
        </div>
      </div>
      {uploadSuccess && (
        <div className="alert alert-success" role="alert">
          {uploadSuccess}
        </div>
      )}
      {uploadError && (
        <div className="alert alert-danger" role="alert">
          {uploadError}
        </div>
      )}

      <div className="flex space-x-2">
        <button
          type="submit"
          className={`px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 ${
            !selectedFile || uploading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          disabled={!selectedFile || uploading}
        >
          {uploading ? 'Uploading...' : `Upload ${fileType}`}
        </button>
        <button
          type="button"
          className={`px-4 py-2 bg-gray-500 text-white font-semibold rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-75 ${
            !selectedFile || uploading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          onClick={handleCancelClick}
          disabled={!selectedFile || uploading}
        >
          Cancel
        </button>
      </div>

    </form>
  );
};

export default S3FileUpload;
